import { Building2, ArrowLeftRight, Ship, WifiOff } from "lucide-react";
import { Btn, PANEL } from "./kit";
import { ACC } from "./util";

export const OfflineBanner = () => (
  <div className="pointer-events-none absolute inset-x-0 top-[112px] z-20 flex justify-center px-3" role="status" data-testid="offline-banner">
    <div className="hud-panel pop flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-semibold" title="You're offline. Reconnecting…">
      <WifiOff className="h-4 w-4 text-x-neg" strokeWidth={2.2} />Offline, reconnecting
    </div>
  </div>
);

const Point = ({ icon: Icon, acc, chip }) => (
  <li className="acc-card flex flex-1 flex-col items-center gap-1 rounded-[10px] py-2" style={{ "--acc": ACC[acc] }}>
    <Icon className="h-6 w-6" strokeWidth={2.2} />
    <span className="text-xs font-semibold tabular-nums">{chip}</span>
  </li>
);

// Signed-out visitors: what the game is, as three icons, and the way in.
export function SignInCta({ at, error, onSignIn }) {
  return (
    <div className="pointer-events-none absolute inset-x-0 z-10 flex justify-center px-3" style={{ bottom: "calc(3rem + env(safe-area-inset-bottom))" }}>
      <div className={`${PANEL} pop pointer-events-auto w-[min(92vw,380px)] rounded-[24px] p-4`} data-testid="sign-in-card">
        <h1 className="text-xl font-semibold">
          {at ? (at.s === "r" ? `@${at.h}'s dock is dark` : at.u ? `@${at.h} lives uptown` : `@${at.h} runs a dock here`) : "Run a dock, earn UXD"}
        </h1>
        <ul className="mt-3 flex gap-2" title="Rent your berths to ships and collect UXD. Trade with other docks to boost your payouts. Rent a house uptown and put your name on billboards.">
          <Point icon={Ship} acc="blue" chip="2× 5× 20×" />
          <Point icon={ArrowLeftRight} acc="green" chip="5–500" />
          <Point icon={Building2} acc="gold" chip="Rent" />
        </ul>
        {at?.s === "r" && <div className="mt-2 text-sm text-x-mute">Yours? Sign in to light it up.</div>}
        {error && <div className="mt-2 rounded-[10px] bg-x-neg-soft px-2 py-1 text-sm font-medium text-x-neg-ink" data-testid="sign-in-error">{error}</div>}
        <Btn onClick={onSignIn} data-testid="sign-in-button" className="mt-3 w-full py-2.5 text-base">Sign in with X</Btn>
      </div>
    </div>
  );
}
